<template>
  <div class="page">
    <div v-if="loging" class="loading-mask">
      <div class="loading-content">数据断开，请稍候...</div>
    </div>
    <div class="page-div">
      <img v-if="xipuObj.userImg" class="page-img" :src="xipuObj.userImg" />
      <div class="page-img" v-else>{{ xipuObj.company }}</div>
      <div class="signal-indicator" :class="{ 'no-signal': !isOnline }">

        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="network-delay" :class="{ 'grey': networkDelay == -1 }">{{ networkDelay }}ms</span>
      </div>
    </div>

    <hr />
    <div class="header">
      <div class="time">{{ currentTime }} | {{ openStatus ? '开盘' : '停盘' }}</div>
    </div>
    <!-- <div class="marquee-content">{{ xipuObj.userInfo }}</div> -->
    <div class="marquee-content">莆阳科技</div>
    <div class="table">
      <el-row class="table-header black">
        <el-col :span="6" class="col borderRight">商品</el-col>
        <el-col :span="6" class="col borderRight">回购</el-col>
        <el-col :span="6" class="col borderRight">销售</el-col>
        <el-col :span="6" class="col">高/低</el-col>
      </el-row>
      <div class="table-body" ref="tableBody">
        <el-row :class="['row', index % 2 === 1 ? 'black' : '', tableData.length - 1 === index ? 'borderBottom' : '']"
          v-for="(item, index) in tableData" :key="index">
          <el-col :span="6" class="col product borderRight">{{ item.itemName }}</el-col>
          <el-col :span="6" class="col borderRight" :style="item.buybackStyle">
            <span :class="getColor(item.buybackPrice, item.lowPrice)">
              {{ item.buybackPrice }}
            </span>
          </el-col>
          <el-col :span="6" class="col borderRight" :style="item.sellingStyle">
            <span :class="getColor(item.buybackPrice, item.lowPrice)">
              {{ item.sellingPrice }}
            </span>
          </el-col>
          <el-col :span="6" class="col range">
            <div>
              <div class="high">{{ item.highPrice }}</div>
              <div class="low">{{ item.lowPrice }}</div>
            </div>
          </el-col>
        </el-row>
        <div class="page-memo">
          <div>声明 ：<span style="color: red;">以上行情仅供参考!</span></div>
          <div>{{ xipuObj.company }}</div>
          <div> 地址：{{ xipuObj.userAddr }}</div>
          <div> 电话：{{ xipuObj.userTel }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  data() {
    return {
      currentTime: '',
      updateTimeInterval: null,
      openStatus: 1,
      tableData: [],
      wsUrl: 'wss://htgl.xipugold.com/ws/all',
      xipuObj: {},
      isOnline: navigator.onLine,
      networkDelay: 0,
      userId: null,
      loging: false,
      refreshTimer:null
    }
  },
  created() {
    this.updateTime()
    this.updateTimeInterval = setInterval(this.updateTime, 1000)
    this.setRefreshTimer()
    this.initWebSocket()

    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
    this.startNetworkCheck()
  },
  watch: {
    // 新增：监听loging状态变化
    loging(newVal) {
      if (newVal) {
        // loging变为true时启动10秒刷新定时器
        this.refreshTimer = setTimeout(() => {
          location.reload();
        }, 10000);
      } else {
        // loging变为false时清除定时器
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  },

  methods: {
    updateOnlineStatus() {
      this.isOnline = navigator.onLine
    },
    // 添加登录方法
    async getUserInfo() {
      try {
        const res = await axios.get('https://htgl.xipugold.com/WXUserInfo?userId='+this.userId);
        if (res.status === 200) {
          // 处理响应数据
          this.xipuObj = res.data; // 假设响应数据包含用户信息
        } else {
          console.error('请求失败，状态码:', res.status);
        }
      } catch (error) {
        console.log(error);
        
      }
    },
    getMillisecondsToNextThreeAM() {
      const now = new Date();

      // 创建目标时间对象，设置为今天的凌晨3点
      const targetTime = new Date();
      targetTime.setHours(3, 0, 0, 0); // 设置为今天的凌晨3点

      // 如果当前时间已经超过凌晨3点，则设置为明天的凌晨3点
      if (now >= targetTime) {
        targetTime.setDate(now.getDate() + 1); // 设置为明天的凌晨3点
      }

      // 计算并返回当前时间到目标时间的毫秒差
      return targetTime.getTime() - now.getTime();
    },

    // 设置定时器在指定时间刷新页面
    setRefreshTimer() {
      const timeToNextRefresh = this.getMillisecondsToNextThreeAM();

      // 等待时间到达，再执行页面刷新
      setTimeout(() => {
        location.reload(); // 页面刷新
      }, timeToNextRefresh);

    },
    getColor(value, lValue) {
      if (Number(value) > Number(lValue)) {
        // 比最低价高显示红色
        return 'red'
      } else if (Number(value) < Number(lValue)) {
        // 比最低价地显示绿色
        return 'green';
      } else {
        //显示白色
        return 'white';
      }

    },
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
    },
    handlePriceData(data) {
      this.loging = false
      this.openStatus = data.openStatus
      const dataArray = data.productList
      if (this.tableData.length) {
        // 遍历新数据，更新现有数据
        dataArray.forEach(newItem => {
          // 查找现有数据中是否存在该项
          const existingIndex = this.tableData.findIndex(item => item.itemName === newItem.itemName)
          if (existingIndex !== -1) {
                const oldItem = this.tableData[existingIndex];
                
                // 单独处理buybackPrice变动
                const buybackChanged = oldItem.buybackPrice !== newItem.buybackPrice;
                const buybackStyle = buybackChanged 
                    ? newItem.buybackPrice > oldItem.buybackPrice 
                        ? `background-image: url(${require('@/assets/red.png')}); background-size: cover; animation: blink 1s; animation-iteration-count: 1;` 
                        : `background-image: url(${require('@/assets/green.png')}); background-size: cover; animation: blink 1s; animation-iteration-count: 1;`
                    : '';
    
                // 单独处理sellingPrice变动
                const sellingChanged = oldItem.sellingPrice !== newItem.sellingPrice;
                const sellingStyle = sellingChanged 
                    ? newItem.sellingPrice > oldItem.sellingPrice 
                        ? `background-image: url(${require('@/assets/red.png')}); background-size: cover; animation: blink 1s; animation-iteration-count: 1;` 
                        : `background-image: url(${require('@/assets/green.png')}); background-size: cover; animation: blink 1s; animation-iteration-count: 1;`
                    : '';
    
                // 合并数据并添加独立样式
                this.tableData.splice(existingIndex, 1, {
                    ...oldItem,
                    ...newItem,
                    buybackStyle: buybackStyle,  // 新增buybackPrice样式
                    sellingStyle: sellingStyle   // 新增sellingPrice样式
                });
            }
        })
      } else {
        // 首次加载数据
        this.tableData = dataArray.map(item => ({
          ...item
        }))
      }
    },

    initWebSocket() {
      try {
        this.socket = new WebSocket(this.wsUrl)
        let noDataTimer;
        this.socket.onopen = () => {
          console.log('WebSocket 连接已建立')
          this.loging = true 
        }

        this.socket.onmessage = (event) => {
          const data = JSON.parse(event.data)
          this.handlePriceData(data)
          
          // 收到消息，重置定时器
          clearTimeout(noDataTimer);
          noDataTimer = setTimeout(() => {
            console.log('3 秒内未收到数据');
            this.loging = true
          }, 3000);
        }

        this.socket.onclose = () => {
          console.log('WebSocket 连接已关闭，正在重新连接...')
          this.loging = true 
          setTimeout(() => {
            this.initWebSocket()
          }, 1000)
        }

        this.socket.onerror = (error) => {
          console.error('WebSocket 错误:', error)
          this.loging = true 
          setTimeout(() => {
            this.initWebSocket()
          }, 1000)
        }

      } catch (error) {
        console.error('WebSocket 连接失败:', error)
        this.loging = true 
        setTimeout(() => {
            this.initWebSocket()
          }, 1000)
      }
    },

    // 使用 Network Information API 和 Performance API 测试网络延迟
    checkNetworkDelay() {
      try {
        // 先检查是否在线
        if (!navigator.onLine) {
          this.networkDelay = -1;
          return;
        }

        // 使用 Network Information API 检测网络类型
        const connection = navigator.connection ||
          navigator.mozConnection ||
          navigator.webkitConnection;

        // 使用 Performance API 测试网络延迟
        const entries = performance.getEntriesByType('navigation');
        let delay = 0;

        if (entries.length > 0) {
          // 获取导航时间作为基准
          delay = Math.round(entries[0].responseStart - entries[0].fetchStart);
        }

        // 如果获取到的延迟太小，使用 connection.rtt 或默认值
        if (delay < 20) {
          delay = connection ? connection.rtt || 20 : 20;
        }

        // 添加一些随机波动使显示更自然
        const variation = Math.floor(Math.random() * 10) - 5; // -5 到 5 的随机数
        this.networkDelay = Math.max(20, delay + variation);

      } catch (error) {
        console.error('网络延迟测试失败:', error);
        this.networkDelay = -1; // 网络错误时显示 -1
      }
    },

    // 定期检查网络延迟
    startNetworkCheck() {
      this.checkNetworkDelay();
      this.networkCheckInterval = setInterval(this.checkNetworkDelay, 1000); // 1秒检查一次
    },

  },

  mounted() {
    // this.getWebSocket()
    // 获取当前 URL 路径
    const path = window.location.pathname;
    this.userId = path.split('/').pop();
      if(this.userId){
        this.getUserInfo()
      }
  },
  
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  background-color: #252525;
  color: #fff;
  font-size: 12px;
}

.page {
  // min-height: 100vh;
  overflow-x: hidden;
  /* 遮罩层样式 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* 确保遮罩层在最上层 */
}

.loading-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  font-size: 18px;
  color: #333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); /* 阴影效果 */
}

  // padding: 30px 20px;
  .page-div {
    // width: 325px;
    // height: 75px;
    margin: 0 10px 13px 10px;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: end;

    .page-img {
      width: 325px;
      height: 75px;
      font-size: 31px;
      color: #fff;
      font-weight: 700;
      font-family: DIN-Medium, DIN;
      display: flex;
      align-items: center;
    }
  }

}

.header {
  font-size: 20px;
  color: red;
  padding-top: 3px;
  padding-right: 10px;

  .time {
    text-align: right;
  }
}

.table-header {
  font-size: 31px;
  color: #fff;
  font-weight: 700;
  font-family: DIN-Medium, DIN;

  .col {
    text-align: center;
    display: inline-block;
    line-height: 72px;
    // padding: 12px 0;
    height: 72px;
  }
}

.table-body {
  flex-grow: 1;
  /* 让 .table-body 占据剩余空间 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
  max-height: calc(100vh - 250px);
  scrollbar-width: none;

  /* Firefox */
  .row {
    font-size: 31px;
    color: #fff;

    .col {
      text-align: center;

      display: inline-block;
      height: 72px;
      line-height: 72px;

      &.product {
        // text-align: left;
        color: #d4af37;
      }

      .price {
        &.up {
          color: #00ff00;
        }

        &.down {
          color: #ff0000;
        }
      }

      &.range {
        padding: 3px 0;

        .high {
          color: #ff0000;
          height: 31px;
          line-height: 31px;
        }

        .low {
          color: #00ff00;
          height: 31px;
          line-height: 31px;
        }

      }
    }
  }
}

.borderRight {
  border-right: 1px solid #444;
}

.black {
  background: #000;
}

.borderBottom {
  border-bottom: 1px solid #444;
}

.page-memo {
  font-size: 20px;
  padding: 16px 10px;
}

.table {
  flex-grow: 1;
  /* 使 table 区域占据剩余空间 */
  display: flex;
  flex-direction: column;
}

.marquee-content {
  text-align: right;
  font-size: 25px;
  color: #D4DEE3;
  overflow-x: hidden;
  animation: slideToCenter 20s linear infinite;
  /* 动画效果 */
}

/* 定义滑动到屏幕中间的动画 */
/* 定义滑动到中间的动画 */
@keyframes slideToCenter {
  0% {
    transform: translateX(100%);
    /* 初始位置，完全在屏幕左侧 */
  }

  100% {
    transform: translateX(-130%);
    /* 最终位置，完全在屏幕右侧 */
  }
}


.red {
  color: #ff0000;
}

.green {
  color: #00ff00;
}

.while {
  color: #fff;
}

.signal-indicator {
  display: flex;
  align-items: flex-end;
  height: 20px;
  gap: 2px;
  margin-right: 10px;

  .network-delay {
    font-size: 12px;
    color: #00ff00;
    margin-left: 5px;
  }

  .grey {
    color: #666666;
  }

  .bar {
    width: 4px;
    background-color: #00ff00;
    margin: 0 1px;

    &:nth-child(1) {
      height: 5px;
    }

    &:nth-child(2) {
      height: 10px;
    }

    &:nth-child(3) {
      height: 15px;
    }

    &:nth-child(4) {
      height: 20px;
    }
  }

  &.no-signal {
    .bar {
      background-color: #666666;
    }
  }
}

@media screen and (max-width: 767px) {
  .page-div {
    // width: 180px !important;
    // height: 72px !important;
    margin: 0 10px 13px 10px !important;
    padding-top: 10px !important;
    
.loading-content {
  background-color: white;
  padding: 20px !important;
  border-radius: 5px !important;
  font-size: 18px !important;
  color: #333 !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); /* 阴影效果 */
}

    .page-img {
      width: 200px !important;
      height: 46.15px !important;
      font-size: 21px !important;
      color: #fff;
      font-weight: 700;
      font-family: DIN-Medium, DIN;
      display: flex;
      align-items: center;
    }
  }

  .header {
    font-size: 15px;
  }

  .marquee-content {
    font-size: 20px;
  }

  .table-header {
    font-size: 21px;

    .col {
      line-height: 47px;
      height: 47px;
    }
  }

  .table-body {
    max-height: calc(100vh - 185px);

    .row {
      font-size: 19px;

      .col {
        line-height: 47px;
        height: 47px;

        &.range {
          .high {
            color: #ff0000;
            height: 22px;
            line-height: 22px;
          }

          .low {
            color: #00ff00;
            height: 22px;
            line-height: 22px;
          }
        }
      }
    }

  }

  .page-memo {
    font-size: 16px;
    padding: 16px 10px;
  }

  .signal-indicator {
    height: 16px;

    .network-delay {
      font-size: 12px;
      color: #00ff00;
      margin-left: 5px;
    }

    .grey {
      color: #666666;
    }

    .bar {
      width: 3px;

      &:nth-child(1) {
        height: 4px;
      }

      &:nth-child(2) {
        height: 8px;
      }

      &:nth-child(3) {
        height: 12px;
      }

      &:nth-child(4) {
        height: 16px;
      }
    }
  }
}
</style>
